import { StateKey } from 'common/utils/flipState'
import { fetchMyInfo, MyInfoParam } from 'common/services/myInfo'
import { initialSizeValue } from 'common/constants/my/sizeInput'

export interface MySizeState {
  height: number
  weight: number
  shoe: number
  tops: string
  bottoms: number
  agreeYn: boolean
  updatedAt?: Date
}

export const initialSizeState: MySizeState = {
  height: initialSizeValue,
  weight: initialSizeValue,
  shoe: initialSizeValue,
  tops: '',
  bottoms: initialSizeValue,
  agreeYn: false,
}
const FETCH_MY_SIZES = 'my/FETCH_MY_SIZES'

export const fetchmyInfo = ({ type, headers }: MyInfoParam, curState: StateKey) => async dispatch => {
  const response = await fetchMyInfo({ type, headers })
  dispatch({
    curState,
    type: FETCH_MY_SIZES,
    myInfo: response && response.data,
  })
}

const myInfoReducer = (state = initialSizeState, action) => {
  switch (action.type) {
    case FETCH_MY_SIZES:
      return action.myInfo
    default:
      return state
  }
}

export default myInfoReducer
